import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    staticClass: "fold"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "name": "状态"
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": undefined
    }
  }, [_vm._v("全部")]), _c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")])], 1)], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "rowKey": "rowNumber",
      "scroll": {
        y: 550
      }
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text, record) {
        return [record.status == 1 ? _c('a-tag', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("已启用")]) : _vm._e(), record.status == 0 ? _c('a-tag', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("已停用")]) : _vm._e()];
      }
    }, {
      key: "type",
      fn: function fn(text) {
        return [text == 1 ? _c('span', [_vm._v("发文")]) : _vm._e(), text == 2 ? _c('span', [_vm._v("收文")]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewClick(record);
            }
          }
        }, [_vm._v("查看")])], 1), _c('a-menu-item', {
          key: "2"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.editClick(record);
            }
          }
        }, [_vm._v("编辑")])], 1), record.status == 0 ? _c('a-menu-item', {
          key: "3"
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "是否确认启用",
            "ok-text": "是",
            "cancel-text": "否"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.statusChange(record.id, record.status);
            }
          }
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          }
        }, [_vm._v("启用")])], 1)], 1) : _vm._e(), record.status === 1 ? _c('a-menu-item', {
          key: "4"
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "是否确认停用",
            "ok-text": "是",
            "cancel-text": "否"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.statusChange(record.id, record.status);
            }
          }
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          }
        }, [_vm._v("停用")])], 1)], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };